import { routingConfig } from '../consts';
import { AppLanguage, RouteGroupName, RouteNameEnum } from '../enums';
import { LangRouteInfo } from '../interfaces';

export function getUrlByRouteName(name: RouteNameEnum, language: AppLanguage = AppLanguage.Pl): LangRouteInfo | undefined {
  for (const [routingGroupName, routingGroupDetails] of Object.entries(routingConfig)) {
    for (const [routeName, routeDetails] of Object.entries(routingGroupDetails.children)) {
      if (routeName === name) {
        return {
          url: `${routingGroupName !== RouteGroupName.Base ? routingGroupDetails.urls[language] : ''}${routeDetails.urls[language]}`,
          title: routeDetails.title,
          secured: routeDetails.secured,
          requiredFunctionalities: routeDetails.requiredFunctionalities,
          roleVisibilityMode: routeDetails.roleVisibilityMode,
        };
      }
    }
  }
}
